import React from "react";

const Footer = () => {
  var d = new Date();
  return (
    <div className="footer">
      <div className="copyright">
        <p>
          Copyright © Gemar Usa by{" "}

          {d.getFullYear()}
        </p>
      </div>
    </div>
  );
};

export default Footer;
